/* global InitialData, URLs */

import {render} from 'react-dom';
import {Provider} from 'react-redux';

import '../utils/legacy';

import UserDefaults from 'topmeteo/general/components/UserDefaults';
import KeyboardControl from 'topmeteo/general/components/KeyboardControl';
import TestNotifications from 'topmeteo/general/components/TestNotifications';

import URLChanger from './components/URLChanger';
import MatrixWrapper, {TypeMap, TypeSat, TypeFlightPlanning} from './components/Matrix';

import {createStore} from '../utils/redux';

import createRootReducer from './reducer';
import {buildURL as baseBuildURL} from './url';

import {baseChangeRegion, dataReloaded, startRequest} from '../general/actionCreators';

export const main = (type, initialState, config = {}) => {
    const {props = {}, createReducer = createRootReducer, confirmChangeAction = null} = config;
    const MatrixControlsNode = document.getElementById('mtx-controls');
    const CSRFMiddlewareTokenNode = MatrixControlsNode.getElementsByTagName('input')[0];
    const CSRFMiddlewareToken = CSRFMiddlewareTokenNode.value;
    const rootReducer = createReducer(initialState);
    const store = createStore(rootReducer, type);
    const buildURL = config.buildURL || (state => baseBuildURL(state, type));
    const changeRegion = id => baseChangeRegion(id, buildURL, confirmChangeAction);

    store.dispatch(dataReloaded({...InitialData, ...URLs, CSRFMiddlewareToken, type, isInitial: true}));
    store.dispatch(startRequest());

    return render(
        <Provider store={store}>
            <URLChanger buildURL={buildURL}>
                <UserDefaults>
                    <TestNotifications />
                    <KeyboardControl type={type} />
                    <MatrixWrapper {...props} type={type} changeRegion={changeRegion} />
                </UserDefaults>
            </URLChanger>
        </Provider>,
        MatrixControlsNode,
    );
};

export {TypeMap, TypeSat, TypeFlightPlanning};
